import gsap from "gsap";
// 离开动画
export function leavePage(pages, index) {
  // const content = pages[index].querySelector('.content');
  switch (index) {
    case 0:
      gsap.to(pages[index].querySelector('.logo'), {
        y: -50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.zhubiao1'), {
        y: -50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.zhubiao2'), {
        y: -50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.xiaozi'), {
        y: 0,
        opacity: 0,
        scaleX: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.logoA'), {
        y: -50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      break;
    case 1:
      gsap.to(pages[index].querySelector('.one'), {
        scale: 0,
        opacity: 0,
        transformOrigin: "center center",
        duration: 1.6,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.xingzhuang'), {
        scaleX: 0,
        opacity: 0,
        duration: 1.3,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.Product'), {
        x: 100,
        opacity: 0,
        duration: 1.8,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.Productview'), {
        y: 20,
        opacity: 0,
        duration: 1.3,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.MANSION'), {
        y: -20,
        opacity: 0,
        duration: 1.3,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.two'), {
        scale: 0,
        opacity: 0,
        transformOrigin: "center center",
        duration: 1.6,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.Space'), {
        x: 100,
        opacity: 0,
        duration: 1.8,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.MANSION2'), {
        y: -20,
        opacity: 0,
        duration: 1.3,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.SpaceScript'), {
        y: 20,
        opacity: 0,
        duration: 1.3,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.xingzhuang2'), {
        scaleX: 0,
        opacity: 0,
        duration: 1.3,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.three'), {
        scale: 0,
        opacity: 0,
        transformOrigin: "center center",
        duration: 1.6,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.Scene'), {
        x: 100,
        opacity: 0,
        duration: 1.8,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.SceneDisplay'), {
        y: 20,
        opacity: 0,
        duration: 1.3,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.MANSION3'), {
        y: -20,
        opacity: 0,
        duration: 1.3,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.xingzhuang3'), {
        scaleX: 0,
        opacity: 0,
        duration: 1.3,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.chanpin'), {
        x: 200,
        opacity: 0,
        duration: 0.6,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.konngjian'), {
        x: 200,
        opacity: 0,
        duration: 0.9,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.changjing'), {
        x: 200,
        opacity: 0,
        duration: 1.2,
        ease: "power2.inOut"
      });
      break;
    case 2:
      gsap.to(pages[index].querySelector('.产品观'), {
        x: -50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.SpaceConcept'), {
        x: 100,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.xingzhuang'), {
        scaleX: 0,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.word2'), {
        y: 20,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.word3'), {
        y: -20,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.word4'), {
        y: 20,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.图片'), {
        scale: 0.8,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      break;
    case 3:
      gsap.to(pages[index].querySelector('.产品观'), {
        x: -50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.DecorationConcept'), {
        x: 100,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.xingzhuang'), {
        scaleX: 0,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.word2'), {
        y: 20,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.word3'), {
        y: -20,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.word4'), {
        y: 20,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.图片'), {
        scale: 0.8,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      break;
    case 4:
      gsap.to(pages[index].querySelector('.空间剧本'), {
        x: -50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.LifeIllustrated'), {
        x: 100,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.xingzhuang'), {
        scaleX: 0,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.word2'), {
        y: 20,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.word4'), {
        y: -20,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.word3'), {
        y: 20,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.shijingtu'), {
        scale: 0.8,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      break;
    case 5:
      gsap.to(pages[index].querySelector('.空间剧本'), {
        x: -50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.tu1'), {
        scale: 0.8,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.闲适'), {
        y: 30,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.tu2'), {
        scale: 0.8,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.垂钓'), {
        y: 30,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.tu3'), {
        scale: 0.8,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.亲子'), {
        y: 30,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      break;
    case 6:
      gsap.to(pages[index].querySelector('.空间剧本'), {
        x: -50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.tu1'), {
        scale: 0.8,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.tu2'), {
        scale: 0.8,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.tu3'), {
        scale: 0.8,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.归家'), {
        y: 30,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.欢聚'), {
        y: 30,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.晚间'), {
        y: 30,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      break;
    case 7:
      gsap.to(pages[index].querySelector('.空间剧本'), {
        x: -50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.HouseType'), {
        scale: 0.8,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.xingzhuang'), {
        scaleX: 0,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.word2'), {
        y: 20,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.word4'), {
        y: -20,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.shijingtu'), {
        scale: 0.8,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      break;
    case 8:
      // gsap.to(pages[index].querySelector('.空间剧本'),
      //   { x: -50, opacity: 0, duration: 1, ease: "power2.inOut" }
      // );
      // gsap.to(pages[index].querySelector('.gohomeImage'),
      //   { x: 50, opacity: 0, duration: 1, ease: "power2.inOut" }
      // );
      // gsap.to(pages[index].querySelector('.LifeIllustrated'),
      //   { scale: 0.8, opacity: 0, duration: 1, ease: "power2.inOut" }
      // );
      // gsap.to(pages[index].querySelector('.xingzhuang'),
      //   { scaleX: 0, opacity: 0, duration: 1, ease: "power2.inOut" }
      // );
      // gsap.to(pages[index].querySelector('.word2'),
      //   { y: 20, opacity: 0, duration: 1, ease: "power2.inOut" }
      // );
      // gsap.to(pages[index].querySelector('.word3'),
      //   { y: -20, opacity: 0, duration: 1, ease: "power2.inOut" }
      // );
      // gsap.to(pages[index].querySelector('.word4'),
      //   { y: 20, opacity: 0, duration: 1, ease: "power2.inOut" }
      // );
      // gsap.to(pages[index].querySelector('.shijingtu'),
      //   { scale: 0.8, opacity: 0, duration: 1, ease: "power2.inOut" }
      // );
      break;
    case 13:
      gsap.to(pages[index].querySelector('.场景展示'), {
        x: -50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.wenzi1'), {
        y: 30,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      var elementsOut = ['.竖线1', '.椭圆黑1', '.全屋', '.中央空调', '.竖线2', '.椭圆黑2', '.竖线3', '.椭圆黑3', '.预留', '.图', '.地暖', '.椭圆黑4', '.竖线4', '.地砖', '.椭圆黑5', '.竖线5'];
      elementsOut.forEach((selector, i) => {
        gsap.to(pages[index].querySelector(selector), {
          opacity: 0,
          y: 20,
          duration: 0.8,
          ease: "power2.inOut",
          delay: i * 0.05
        });
      });
      break;
    case 14:
      // 退出时，按反向顺序执行动画
      gsap.to(pages[index].querySelector('.场景展示'), {
        x: -50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.图'), {
        opacity: 0,
        y: 20,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.wenzi1'), {
        opacity: 0,
        y: 20,
        duration: 1,
        ease: "power2.inOut"
      });

      // 按顺序依次消失
      elementsOut = ['.竖线1', '.椭圆黑1', '.阳台面宽', '.竖线2', '.椭圆黑2', '.预留洗衣机', '.大尺寸地砖', '.椭圆黑5', '.竖线5', '.预留洗手池', '.椭圆黑6', '.竖线6'];
      elementsOut.forEach((selector, i) => {
        gsap.to(pages[index].querySelector(selector), {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: "power2.inOut",
          delay: 0.5 + i * 0.1
        });
      });
      break;
    case 15:
      // 退出动画
      elementsOut = ['.竖线1', '.椭圆黑1', '.阳台mini', '.竖线2', '.椭圆黑2', '.双边床头', '.椭圆黑3', '.zhexian', '.预留灵活空间', '.椭圆黑5', '.竖线5', '.尊享', '.椭圆黑6', '.竖线6', '.预留男女'];
      gsap.to(pages[index].querySelector('.场景展示'), {
        x: -50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.图'), {
        opacity: 0,
        y: 20,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.wenzi1'), {
        opacity: 0,
        y: 20,
        duration: 1,
        ease: "power2.inOut"
      });

      // 按顺序依次消失
      elementsOut.forEach((selector, i) => {
        gsap.to(pages[index].querySelector(selector), {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: "power2.inOut",
          delay: 0.5 + i * 0.1
        });
      });
      break;
    case 16:
      // 退出动画
      elementsOut = ['.zhexian', '.椭圆黑1', '.沐光', '.竖线2', '.椭圆黑2', '.阳台推拉门', '.地砖', '.椭圆黑5', '.竖线5', '.成长', '.椭圆黑6', '.竖线6'];
      gsap.to(pages[index].querySelector('.场景展示'), {
        x: -50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.图'), {
        opacity: 0,
        y: 20,
        duration: 1,
        ease: "power2.inOut"
      });
      gsap.to(pages[index].querySelector('.wenzi1'), {
        opacity: 0,
        y: 20,
        duration: 1,
        ease: "power2.inOut"
      });

      // 按顺序依次消失
      elementsOut.forEach((selector, i) => {
        gsap.to(pages[index].querySelector(selector), {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: "power2.inOut",
          delay: 0.5 + i * 0.1
        });
      });
      break;

    // case 13 - Exit Animation
    case 17:
      // Define elements to animate
      elementsOut = ['.zhexian', '.椭圆黑2', '.灵感', '.竖线2', '.椭圆黑5', '.竖线5', '.灵动'];

      // Animating "场景展示" (Scene Display) exit
      gsap.to(pages[index].querySelector('.场景展示'), {
        x: -50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });

      // Animating "返回首页" (Home Button) exit
      gsap.to(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });

      // Animating "图" element exit
      gsap.to(pages[index].querySelector('.图'), {
        opacity: 0,
        y: 20,
        duration: 1,
        ease: "power2.inOut"
      });

      // Animating text elements like "wenzi1"
      gsap.to(pages[index].querySelector('.wenzi1'), {
        opacity: 0,
        y: 20,
        duration: 1,
        ease: "power2.inOut"
      });

      // Hide other elements sequentially
      elementsOut.forEach((selector, i) => {
        gsap.to(pages[index].querySelector(selector), {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: "power2.inOut",
          delay: 0.5 + i * 0.1
        });
      });
      break;
    // case 14 - Exit Animation
    case 18:
      // Define elements to animate
      elementsOut = ['.zhexian', '.椭圆黑2', '.灵感', '.竖线2', '.椭圆黑5', '.竖线5', '.灵动'];

      // Animating "场景展示" (Scene Display) exit
      gsap.to(pages[index].querySelector('.场景展示'), {
        x: -50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });

      // Animating "返回首页" (Home Button) exit
      gsap.to(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });

      // Animating "wenzi1" (Text) exit
      gsap.to(pages[index].querySelector('.wenzi1'), {
        opacity: 0,
        y: 20,
        duration: 1,
        ease: "power2.inOut"
      });

      // Animating "图" (Image) exit
      gsap.to(pages[index].querySelector('.图'), {
        opacity: 0,
        y: 20,
        duration: 1,
        ease: "power2.inOut"
      });

      // Hide other elements sequentially
      elementsOut.forEach((selector, i) => {
        gsap.to(pages[index].querySelector(selector), {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: "power2.inOut",
          delay: 0.5 + i * 0.1
        });
      });
      break;

      // Define elements to animate
      elementsOut = ['.椭圆黑1', '.竖线1', '.沐浴区', '.竖线11', '.椭圆黑11', '.窄边', '.zuozhexian', '.镜柜壁龛', '.椭圆黑2', '.轻智能壁挂式马桶', '.竖线12', '.椭圆黑12', '.无影美妆灯', '.地漏', '.椭圆黑3', '.youzhexian', '.椭圆黑5', '.竖线5', '.淋浴区整面踏板', '.椭圆黑51', '.youzhexian2', '.马桶上方收纳', '.椭圆黑6', '.竖线6', '.尊享星级卫浴'];

      // Animating "场景展示" (Scene Display) exit
      gsap.to(pages[index].querySelector('.场景展示'), {
        x: -50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });

      // Animating "返回首页" (Home Button) exit
      gsap.to(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });

      // Animating "图" element exit
      gsap.to(pages[index].querySelector('.图'), {
        opacity: 0,
        y: 20,
        duration: 1,
        ease: "power2.inOut"
      });

      // Animating text elements like "wenzi1"
      gsap.to(pages[index].querySelector('.wenzi1'), {
        opacity: 0,
        y: 20,
        duration: 1,
        ease: "power2.inOut"
      });

      // Hide other elements sequentially
      elementsOut.forEach((selector, i) => {
        gsap.to(pages[index].querySelector(selector), {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: "power2.inOut",
          delay: 0.5 + i * 0.1
        });
      });
      break;
    case 19:
      // Define elements to animate
      elementsOut = ['.椭圆黑11', '.竖线11', '.窄边', '.竖线112', '.椭圆黑112', '.沐浴', '.椭圆黑2', '.台下', '.竖线12', '.椭圆黑12', '.定制', '.椭圆黑5', '.竖线5', '.椭圆黑6', '.竖线6', '.品牌'];

      // Animating "场景展示" (Scene Display) exit
      gsap.to(pages[index].querySelector('.场景展示'), {
        x: -50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });

      // Animating "返回首页" (Home Button) exit
      gsap.to(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });

      // Animating "图" element exit
      gsap.to(pages[index].querySelector('.图'), {
        opacity: 0,
        y: 20,
        duration: 1,
        ease: "power2.inOut"
      });

      // Animating text elements like "wenzi1"
      gsap.to(pages[index].querySelector('.wenzi1'), {
        opacity: 0,
        y: 20,
        duration: 1,
        ease: "power2.inOut"
      });

      // Hide other elements sequentially
      elementsOut.forEach((selector, i) => {
        gsap.to(pages[index].querySelector(selector), {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: "power2.inOut",
          delay: 0.5 + i * 0.1
        });
      });
      break;
    case 20:
      // Define elements to animate
      elementsOut = ['.竖线2', '.椭圆黑2', '.预留', '.超低', '.椭圆黑5', '.竖线5', '.收纳', '.椭圆黑6', '.竖线6'];

      // Animating "场景展示" (Scene Display) exit
      gsap.to(pages[index].querySelector('.场景展示'), {
        x: -50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });

      // Animating "返回首页" (Home Button) exit
      gsap.to(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut"
      });

      // Animating "图" element exit
      gsap.to(pages[index].querySelector('.图'), {
        opacity: 0,
        y: 20,
        duration: 1,
        ease: "power2.inOut"
      });

      // Animating text elements like "wenzi1"
      gsap.to(pages[index].querySelector('.wenzi1'), {
        opacity: 0,
        y: 20,
        duration: 1,
        ease: "power2.inOut"
      });

      // Hide other elements sequentially
      elementsOut.forEach((selector, i) => {
        gsap.to(pages[index].querySelector(selector), {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: "power2.inOut",
          delay: 0.5 + i * 0.1
        });
      });
      break;
    default:
  }
}